import axios from "axios";
import {
  axiosFormDataConfigs,
  getFormData,
} from "../../../../_emywork/helpers/AxiosHelpers";
import { toAbsoluteApiUrl } from "../../../../_metronic/_helpers";

export const API_URI = toAbsoluteApiUrl("/deposit/deposit-money");

const normalize = (_entity) => {
  let entity = { ..._entity };
  delete entity.created_at;
  delete entity.updated_at;

  return entity;
};
export const create = (entity, files) =>
  axios.post(
    API_URI,
    getFormData(normalize(entity), files),
    axiosFormDataConfigs
  );
